import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Reports|Recently Reimported Exams|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

export type SPReportsRecentlyReimportedExamsLocNames =
	| 'SPReportsRecentlyReimportedExamsTitleTab'
	| 'SPReportsRecentlyReimportedExamsTitlePage'
	| 'SPReportsRecentlyReimportedExamsTitleSection'
	| 'SPReportsRecentlyReimportedExamsButtonViewDetails'
	| 'SPReportsRecentlyReimportedExamsLabelReImportedDate'
	| 'SPReportsRecentlyReimportedExamsLabelDataProvider'
	| 'SPReportsRecentlyReimportedExamsLabelTotal'
	| 'SPReportsRecentlyReimportedExamsLabelDetails'
	| 'SPReportsRecentlyReimportedExamsLabelDownload';

export const spReportsRecentlyReimportedExamsLocs: LocDefs<SPReportsRecentlyReimportedExamsLocNames> =
	{
		SPReportsRecentlyReimportedExamsTitleTab: {
			defaultValue: 'Recently Re-Imported Exams Report',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.RecentlyReImportedExams.Title.TabTitle',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsTitlePage: {
			defaultValue: 'Recently Re-Imported Exams Report',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.RecentlyReImportedExams.Title.PageTitle',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsTitleSection: {
			defaultValue: 'Recently Re-Imported Exams Report',
			description: 'Section Title',
			displayPath: `${pathStart}Section Title`,
			displayType: 'Title',
			legacyName: 'Exam/Reporting.RecentlyReImportedExams.Title.SectionTitle',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsButtonViewDetails: {
			defaultValue: 'View',
			description: 'Link to view the details of the exam.',
			displayPath: `${pathStart}View`,
			displayType: 'Button',
			legacyName: 'Exam/Reporting.RecentlyReImportedExams.Button.View',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsLabelReImportedDate: {
			defaultValue: 'Re-Import Date',
			description: 'Column heading for: Re-Import Date.',
			displayPath: `${pathStart}Re-Import Date`,
			displayType: 'Label',
			legacyName: 'Exam/Reporting.RecentlyReImportedExams.ColumnHeading.ImportDate',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsLabelDataProvider: {
			defaultValue: 'Data Provider',
			description: 'Column heading for: Data Provider.',
			displayPath: `${pathStart}Data Provider`,
			displayType: 'Label',
			legacyName: 'Exam/Reporting.RecentlyReImportedExams.ColumnHeading.DataProvider',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsLabelTotal: {
			defaultValue: 'Total',
			description: 'Column heading for: Total.',
			displayPath: `${pathStart}Total`,
			displayType: 'Label',
			legacyName: 'Exam/Reporting.RecentlyReImportedExams.ColumnHeading.Total',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsLabelDetails: {
			defaultValue: 'Details',
			description: 'Column heading for: Details.',
			displayPath: `${pathStart}Details`,
			displayType: 'Label',
			legacyName: 'Exam/Reporting.RecentlyReImportedExams.ColumnHeading.Detail',
			...sharedProperties,
		},
		SPReportsRecentlyReimportedExamsLabelDownload: {
			defaultValue: 'Download',
			description: 'Column heading for: Download.',
			displayPath: `${pathStart}Download`,
			displayType: 'Label',
			...sharedProperties,
		},
	};

export type SPReportsRecentlyReimportedExamsLocType =
	LocMap<SPReportsRecentlyReimportedExamsLocNames>;
